import Vue from 'vue'

Vue.directive('action-rotate', {
  bind (el) {
    let current = 0
    el.addEventListener('click', function () {
      current += 360
      this.style.transform = `rotate(${current}deg)`
      this.style.transitionDuration = '1s'
    })
  }
})



// WEBPACK FOOTER //
// ./src/libs/directives/rotate.js